import { MolsonAccordion, MolsonBox } from '@components/reusable'
import type { AutocompleteRenderGroupParams } from '@mui/material'
import { useEffect, useState } from 'react'

type MolsonAutoCompleteTreeViewProps = AutocompleteRenderGroupParams & {
  searchTerm?: string
}

export const MolsonAutoCompleteTreeView = ({
  key,
  children,
  group,
  searchTerm
}: MolsonAutoCompleteTreeViewProps) => {
  const [expanded, setExpanded] = useState(false)

  useEffect(() => {
    if (searchTerm && searchTerm.length > 0) {
      setExpanded(true)
    }
  }, [searchTerm])

  return (
    <li
      key={key}
      style={{
        margin: '6px 2px'
      }}
    >
      <MolsonAccordion
        sx={{
          '&::after': {
            opacity: 0
          }
        }}
        detailsSx={{
          padding: 0
        }}
        summarySx={{
          padding: '10px 8px !important',
          margin: 0,
          gap: '8px',
          flexDirection: 'row-reverse',
          minHeight: '1px',
          '& .MuiAccordionSummary-content': {
            margin: 0
          }
        }}
        size="sm"
        primaryTextVariant="body1"
        primaryText={`${group} Months`}
        expanded={expanded}
        onClick={() => setExpanded(prev => !prev)}
      >
        <MolsonBox
          sx={{
            marginLeft: '56px'
          }}
        >
          {children}
        </MolsonBox>
      </MolsonAccordion>
    </li>
  )
}
